import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonGroupComponent } from './components/button-group/button-group.component';
import { ButtonLegacyModule } from '../button-legacy/button-legacy.module';

@NgModule({
  declarations: [ButtonGroupComponent],
  imports: [CommonModule, ButtonLegacyModule],
  exports: [ButtonGroupComponent],
})
export class ButtonGroupModule {}
